import React, { useState } from 'react'
import { ScagliePageConfig } from '../configuration'
import AssignId from '../AssignId'
import Container from '../Container'
import styles from './Scaglie.module.sass'
import formato60x120 from './assets/images/formato60x120.png'
import formato120x120 from './assets/images/formato120x120.png'
import scaglieFumo from './assets/images/Cera_Scaglie_Fumo_120x120_small.jpg'
import scaglieFumoZoom from './assets/images/Cera_Scaglie_Fumo_120x120.jpg'
import scaglieMulticolore from './assets/images/Cera_Scaglie_Multicolore_120x120_small.jpg'
import scaglieMulticoloreZoom from './assets/images/Cera_Scaglie_Multicolore_120x120.jpg'
import scaglieIncenso from './assets/images/Cera_Scaglie_Incenso_120x120_small.jpg'
import scaglieIncensoZoom from './assets/images/Cera_Scaglie_Incenso_120x120.jpg'
import VisibilitySensor from '../VisibilitySensor'
import PhotoModal from './PhotoModal'

export default function Scaglie() {

  const conf = {
    intro: 'Scaglie',
    titolo: 'Modulo Scaglie**',
    descrizione: 'La grafica Scaglie, disponibile in entrambe le finiture Cerasilk e Matt-Pro, risulta ideale sia per la posa a pavimento che come rivestimento parete. Piccoli frammenti di cera nelle tonalità Fumo, Incenso o nella variante Multicolor si propagano sul fondo Luce, conferendo al prodotto un senso di complessità e un\'immagine delicatamente ritmata.',
    images: [
      { label: 'Fumo', src: scaglieFumo, srcZoomed: scaglieFumoZoom },
      { label: 'Multicolore', src: scaglieMulticolore, src: scaglieMulticoloreZoom },
      { label: 'Incenso', src: scaglieIncenso, src: scaglieIncensoZoom },
    ],
    formati: {
      titolo: 'Disponibile nei formati',
      items: [
        { src: formato60x120, titolo: '60x120', sottotitolo: '24"x48"' },
        { src: formato120x120, titolo: '120x120', sottotitolo: '48"x48"' },
      ]
    }
  }

  const [activeImage, setActiveImage] = useState(0)

  return (
    <Container size="md">
      <div className={styles.root}>
        <AssignId
          absolute
          y='-120px'
          yMobile='-80px'
          id='scaglie'
        />
        <VisibilitySensor index={4} />
        <div className={styles.layout}>
          <div className={`${styles.content} scroll-fadein`}>
            <p className={styles.intro}>{ScagliePageConfig.intro}</p>
            <h2 className={styles.title}>{ScagliePageConfig.titolo}</h2>
			<div className={styles.description} dangerouslySetInnerHTML={{ __html: ScagliePageConfig.descrizione }} />
            <div className={styles.formati}>
              <h3 className={styles.formatiTitle}>{ScagliePageConfig.formati.titolo}</h3>
              <div className={styles.formatiList}>
                {conf.formati.items.map((x, index) => (
                  <div className={styles.formatiItem} key={index}>
                    <img src={x.src} alt={x.titolo} />
                    <div className={styles.formatiItemContent}>
                      <p className={styles.formatiItemTitle}>{x.titolo}</p>
                      <p className={styles.formatiItemDescription}>{x.sottotitolo}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={`${styles.galleryBox}`}>
            <div className={styles.powerBarBox}>
              <div className={styles.powerBar}>
                {conf.images.map((x, index) => (
                  <button 
                    key={index}
                    type="button" 
                    onClick={() => setActiveImage(index)} 
                    className={`${styles.powerBarItem} ${index === activeImage ? styles['powerBarItem--active'] : ''} `}
                  >{x.label}</button>
                ))}
              </div>
            </div>
            <div className={styles.imageBox}>
              {conf.images.map((x, index) => (
                <div className={`${styles.zoom} ${index === activeImage ? styles['zoom--active'] : ''}`}>
                  <PhotoModal img={x.src} zoomedImg={x.srcZoomed} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}
